// import external dependencies
import jquery from 'jquery';

declare global {
  interface Window {
    $: typeof jquery;
    jQuery: typeof jquery;
  }
}

window.$ = window.jQuery = jquery;

import 'bootstrap/js/dist/modal';
import 'bootstrap/js/dist/offcanvas';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/tab';
import 'bootstrap/js/dist/dropdown';

import './modules/sticky-header';
import './modules/modal';
import './modules/scroll';
import './modules/sliders';
import './modules/dropdown';
import './modules/share-desktop';
import './modules/share-mobile';
import './modules/video-yt';
import './modules/fancybox';
import './modules/search';
import './modules/aos';
